const actions = {
  LOGIN_BEGIN: 'LOGIN_BEGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERR: 'LOGIN_ERR',

  VERIFY_TWO_BEGIN: 'VERIFY_TWO_BEGIN',
  VERIFY_TWO_SUCCESS: 'VERIFY_TWO_SUCCESS',
  VERIFY_TWO_ERR: 'VERIFY_TWO_ERR',

  CHANGE_PASSWORD_BEGIN: 'CHANGE_PASSWORD_BEGIN',
  CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
  CHANGE_PASSWORD_ERR: 'CHANGE_PASSWORD_ERR',

  LOGOUT_BEGIN: 'LOGOUT_BEGIN',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_ERR: 'LOGOUT_ERR',

  loginBegin: () => {
    return {
      type: actions.LOGIN_BEGIN,
    };
  },

  loginSuccess: data => {
    return {
      type: actions.LOGIN_SUCCESS,
      data,
    };
  },

  loginErr: err => {
    return {
      type: actions.LOGIN_ERR,
      err,
    };
  },
  verifyTwoFaBegin: () => {
    return {
      type: actions.VERIFY_TWO_BEGIN,
    };
  },

  verifyTwoFaSuccess: data => {
    /* console.log('data', data); */
    return {
      type: actions.VERIFY_TWO_SUCCESS,
      data,
    };
  },

  verifyTwoFaErr: err => {
    return {
      type: actions.VERIFY_TWO_ERR,
      err,
    };
  },
  changePasswordBegin: () => {
    return {
      type: actions.CHANGE_PASSWORD_BEGIN,
    };
  },

  changePasswordSuccess: data => {
    return {
      type: actions.CHANGE_PASSWORD_SUCCESS,
      data,
    };
  },

  changePasswordErr: err => {
    return {
      type: actions.CHANGE_PASSWORD_ERR,
      err,
    };
  },

  logoutBegin: () => {
    return {
      type: actions.LOGOUT_BEGIN,
    };
  },

  logoutSuccess: data => {
    return {
      type: actions.LOGOUT_SUCCESS,
      data,
    };
  },

  logoutErr: err => {
    return {
      type: actions.LOGOUT_ERR,
      err,
    };
  },
};

export default actions;
